import * as _ from 'lodash';
import * as moment from 'moment-timezone';
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input, EventEmitter, Output, OnDestroy, HostListener } from '@angular/core';
import {  LangService } from '../../core/lang.service';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
import { Observable, Subject, Subscription } from 'rxjs';
import { LoginGuardService } from '../../api/login-guard.service';
import { ISectionDef, ITestDef, ISectionMeta } from '../sample-questions/data/sections';
import { reject } from 'q';
import { FormControl } from '@angular/forms';
import { AuthService, getFrontendDomain, MPT_REMOTE_PROCTOR_URL } from '../../api/auth.service';
import { RoutesService } from '../../api/routes.service';
import { TextToSpeechService } from '../text-to-speech.service';
import { IQuestionConfig, IQuestionRun } from '../../ui-item-maker/item-set-editor/models';
import { ElementType,IContentElementIframe } from '../models';
import {ChatService, IVideoCallRequest} from '../../chat/chat.service';
import { HttpClient } from '@angular/common/http';
import { IMenuTabConfig } from '../../ui-partial/menu-bar/menu-bar.component';
import { IAssessmentFrameworkDetail, TestFormConstructionMethod } from 'src/app/ui-item-maker/item-set-editor/models/assessment-framework';
import { DrawDisplayMode } from '../element-render-drawing/constants';
import { IDur, IPanelModuleDef, renderDur } from '../../ui-testtaker/view-tt-test-runner/view-tt-test-runner.component';
import { randArrEntry } from '../../ui-testadmin/demo-data.service';
import { WhitelabelService } from '../../domain/whitelabel.service';
import { UrlLoaderService } from '../url-loader.service';
import { DevtoolsDetectService } from 'src/app/core/devtools-detect.service';
import { SEBService } from 'src/app/ui-testtaker/seb.service';
import { downloadStr } from 'src/app/core/download-string';
import { PageModalController, PageModalService } from 'src/app/ui-partial/page-modal.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MirotalkMessageEvent, MPT_REMOTE_PROCTOR_DOMAIN, RemoteProctoringService } from 'src/app/api/remote-proctoring.service';
import { filter } from 'rxjs/operators';
import { TimezoneService } from 'src/app/core/timezone.service';
import { StressTestService } from '../stress-test.service';
import { ElementLogService, ILogResponse } from '../element-log.service';
import { InteractionTrackingService } from '../interaction-tracking.service'

interface ITestState {
  languageCode: string;
  currentSectionIndex: number;
  currentQuestionIndex: number;
  questionStates: any;
  isSubmitted?: boolean;
  notes?: string;
}
interface ISectionState{
  numUnfilledResponses?: number;
  timeSpent?:number;
}

interface IQuestionSaveError {
  slug: string;
  dismiss: boolean;
  skip: boolean;
  customBtn: boolean;
  btn: string;
  errorAction?: () => void;
}

enum EXCLUDE_ITEM_OPEN_LOG_REASONS {
  NEW_SECT_PREAMBLE = 'NEW_SECT_PREAMBLE',
  NG_DESTROY = "NG_DESTROY"
}

// FPS related const
const DEFAULT_LINEREADER_WIDTH = 1000;
const SECOND_MS = 1000;
const IDLE_CHECK_FREQENCY = 1000;  // in millisecond
const FPS_CHECK_FREQENCY = 1000;  // in millisecond
const GOOD_FPS = 30;  // fps above 30 is good
const POOR_FPS = 10;   // fps below 10 is poor
                      // fps between 10-30 is adequate
enum FPSStatus {
  GOOD = "GOOD",
  ADEQUATE = 'ADEQUATE',
  POOR = "POOR",
}

const concatObjects = (...sources) => {
  const target = {};
  sources.forEach(el => {
     Object.keys(el).forEach(key => {
        target[key] = el[key];
     });
  });
  return target;
}

export enum STUDENT_ACTIVITY_SLUGS {
  STUDENT_TEST_ITEM_OPEN = "STUDENT_TEST_ITEM_OPEN",
  STUDENT_TEST_ITEM_NAVIGATE_AWAY = "STUDENT_TEST_ITEM_NAVIGATE_AWAY",
  STUDENT_TEST_ITEM_KEEP_ALIVE = "STUDENT_TEST_ITEM_KEEP_ALIVE",
  STUDENT_SECTION_INFO_OPEN = "STUDENT_SECTION_INFO_OPEN",
  STUDENT_SECTION_INFO_CLOSE = "STUDENT_SECTION_INFO_CLOSE",
  STUDENT_ASMT_ITEM_RESPONSE = "STUDENT_ASMT_ITEM_RESPONSE",
  STUDENT_ASMT_TOOL_TTS = 'STUDENT_ASMT_TOOL_TTS'
}

const ITEM_RESAVE_INTERVAL = 60*1000; //every minute, trigger a save

@Component({
  selector: 'test-runner',
  templateUrl: './test-runner.component.html',
  styleUrls: ['./test-runner.component.scss']
})
export class TestRunnerComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('questionDisplay', { static: false }) questionDisplay: ElementRef<HTMLDivElement>;
  @ViewChild('topBar', { static: false }) topBar: ElementRef<HTMLDivElement>;
  @ViewChild('infoButton', { static: false }) infoButton: ElementRef<HTMLButtonElement>;
  @ViewChild('toolbarRef', { static: false }) toolbarRef: ElementRef<HTMLDivElement>;
  @ViewChild('currentQuestionHeading', { static: false }) currentQuestionHeading: ElementRef<HTMLHeadingElement>;
  @ViewChild('timeRemainingMessage', { static: false }) timeRemainingMessage: ElementRef<HTMLElement>;
  @ViewChild('chatHeading', { static: false }) chatHeading: ElementRef<HTMLElement>;
  @ViewChild('completionReportMessage', { static: false })
  set completionReportMessage(message: ElementRef<HTMLElement>) {
    if (message) {
      this.scheduleCompletionReportFocus(message.nativeElement);
    }
  }
  @ViewChild('completionActionButton', { static: false })
  set completionActionButton(button: ElementRef<HTMLButtonElement>) {
    if (button && this.testSessionId === -1) {
      this.scheduleCompletionReportFocus(button.nativeElement);
    }
  }

  @Input() asmtFmrk: IAssessmentFrameworkDetail;
  @Input() testTakerName: string;
  @Input() confirmReportData: Object;
  @Input() testFormType: string;
  @Input() testFormId: number;
  @Input() currentTestDesign: ITestDef;
  @Input() questionSrcDb: Map<number, IQuestionRun>;
  @Input() testLang: string;
  @Input() testSessionId: number;
  @Input() attemptKey: string;
  @Input() sectionIndexInit: number;
  @Input() questionIndexInit: number;
  @Input() isIssueReportingEnabled: boolean;
  @Input() questionStates: {[key: string]: any};
  @Input() dateTimeStart: moment.Moment;
  @Input() dateString:string;
  @Input() startedOn:string;
  @Input() regularTimeRemaining: IDur;
  @Input() isPrintMode: boolean;
  @Input() isNavFooterDisabled: boolean;
  @Input() isChatEnabled: boolean;
  @Input() isTimeEnabled: boolean = true;
  @Input() isHelpEnabled: boolean = true;
  @Input() autoScrollOnSelect: boolean = false;
  @Input() isText2SpeechEnabled: boolean = true;
  @Input() isShowQuestionLabel: boolean;
  @Input() documentItems: {itemId:number, caption:string}[];
  @Input() helpPageItem: number;
  @Input() isExitEnabled: boolean;
  @Input() checkTime: () => Promise<any>;
  @Input() checkChat: () => Promise<any>;
  @Input() instit_group_id: number;
  @Input() institution: string;
  @Input() format: string;
  @Input() timeSpentSinceStart:string;
  @Input() attemptHash: string;
  @Input() isVideoOnline: boolean;
  @Input() isRemote?: boolean;
  @Input() isOnBreak: boolean = false;
  @Input() showFPS = false;
  @Input() disableDrawingTools: boolean = false;

  @Input() saveQuestion: (data: any) => Promise<any>;
  @Input() acceptAttestation?: (data: any) => Promise<any>;
  @Input() updateWellnessBreak: (take_break: boolean) => Promise<any>;
  @Input() submitTest: () => Promise<any>;
  @Input() goToDashboard: () => any;
  @Output() exit = new EventEmitter();
  @Output() refreshConference = new EventEmitter();

  @Output() tempCloseConfOnPrivateCall? = new EventEmitter();
  
  @Output() getCurrentState = new EventEmitter<any>();

  dayStarted: number;
  yearStarted: number;
  isShowFormulaSheet = false;
  isShowDocuments = false;
  showEraser = false;
  showLine = false;
  showHighlight = false;
  transValue
  drawMode = '';
  currIEZoom = 100
  isShowOverlay = false;
  showDeactivatedMode = false;
  isZoomIn = false;
  isZoomOut = false;
  overlayState ={
    "off":true,
    "on":false,
    "deactivate":false
  }
  iframeUrl
  element:IContentElementIframe = {
     elementType:ElementType.IFRAME,
     url:''
  }
  lineReaderPosition: {x: number, y: number} = {x: 0, y: 0};
  monthSlugs = {0:'lbl_reportDate_jan', 1:'lbl_reportDate_feb', 2:'lbl_reportDate_mar',
  3:'lbl_reportDate_apr', 4:'lbl_reportDate_may', 5:'lbl_reportDate_jun',
  6:'lbl_reportDate_july', 7:'lbl_reportDate_aug', 8:'lbl_reportDate_sep',
  9:'lbl_reportDate_oct', 10:'lbl_reportDate_nov', 11:'lbl_reportDate_dec'};
  previousSessionMeta: { [key: string]: ISectionState };
  currSection: string;
  isSubmitting: boolean =false;
  report: any;
  reportError: boolean;
  reportErrorMsg: any;

  private devtoolsSub: Subscription;
  private currentQuestionFocusTimer: number;
  private currentQuestionFocusFrame: number;
  private popupFocusFrames: Map<string, number> = new Map();
  private timeRemainingPreviouslyFocusedElement: HTMLElement;
  private chatPreviouslyFocusedElement: HTMLElement;
  isDebugMode:boolean;
  lastResponseDebug:{label:string, test_question_id:number, formatted_response:string, score:number, weight:number}
  previousLoggedItemOpenId: number;
  currentTestQuestionStartTime: number; // epoch

  public mirotalkEvent$: Observable<MirotalkMessageEvent> | null = null;
  private mirotalkSub: Subscription;

  constructor(
    public lang: LangService,
    private loginGuard: LoginGuardService,
    private location: Location,
    private router: Router,
    private routes: RoutesService,
    public auth: AuthService,
    private route: ActivatedRoute,
    private textToSpeech: TextToSpeechService,
    private httpClient: HttpClient,
    public chatService: ChatService,
    private whitelabel: WhitelabelService,
    private safeUrl: UrlLoaderService,
    private seb: SEBService,
    private devtoolsDetect: DevtoolsDetectService,
    private pageModalService: PageModalService,
    private sanitizer: DomSanitizer,
    private remoteProctoringService: RemoteProctoringService,
    private timezone: TimezoneService,
    private stressTestService: StressTestService,
    private elementLog: ElementLogService,
    private interactionTracking: InteractionTrackingService,
  ) { }

  zoomLevel = 1;
  minZoomLevel = 0.6;
  maxZoomLevel = 2;
  zoomIncrement = 0.2;

  testState: ITestState;

  routeSub: Subscription;

  isSyncing: boolean;

  isShowingSectionInfo: boolean;
  isFormulasToggledOn: boolean;
  isCalcToggledOn: boolean;
  isHighContrast: boolean;
  isNotepadEnabled: boolean = false;
  isHelpOverlay: boolean;
  sectionTime: number;
  sectionTimeRemaining;
  helpScreenLayout:any;
  isShowingConfirmationReport:boolean;
  ticker;
  questionResaveInterval;
  isPaused: boolean = false;
  isConferenceRequested: boolean = false;
  notePadLogState = {
    logOnChange: true,
    logOnBlure: false,
  };
  isSavingResponse: boolean;
  currentModal: any;
  isShowingTime;
  isShowingChat:boolean = false;
  isShowingReport;
  issueReportMessage = new FormControl();
  isLineReaderActive: boolean;
  isTestNavExpanded: boolean;
  isToolbarExpanded: boolean;

  documentViews: IMenuTabConfig<number>[];
  selectedDocumentId:number;
  numUnfilledQbySection:number;
  sectionTimeSpent = [];
  sessionMeta: { [key: string]: ISectionState };

  isLogsVisible = false;
  logQueue:any[] = []

  renderDur = renderDur;
  sectionTimeStarted: number;

  // FPS and hardware performance check props
  lastFrameLoopCheck = new Date();
  frameCount = 0;
  backgroundTimeElapsed = 0;
  backgroundDiagnosticsInterval;
  currentFPS
  currentFpsStatus
  currentFpsStatusText
  FPSStatus = FPSStatus
  timeoutId: NodeJS.Timeout;
  userIdling = false;
  userInactive: Subject<any> = new Subject();
  public fpsSamples: number[] = [];
  perfTestStartDate: Date | undefined;

  ngOnInit() {
    if (!this.isPrintMode){
      window.scrollTo(0, 0);
    }
    this.isDebugMode = !! this.devtoolsDetect.debugModePass

    this.initToolbarOption();
    this.initTestDef();
    this.initTestState();
    this.initTicker();

    if (this.isChatEnabled){
      this.initChatPage();
    }
    if (this.isHelpEnabled){
      this.initHelpPage();
    }

    this.documentViews = [];
    if (this.documentItems){
      Promise.all(
        this.documentItems.map(document => {
          this.documentViews.push({
            id: document.itemId,
            caption: document.caption,
          })
          return this.loadDocument(document.itemId);
        })
      )
      .then(()=>{
        this.selectDocumentView(this.documentItems[0].itemId)
      });
    }

    this.pageModal = this.pageModalService.defineNewPageModal();

    this.pageModal = this.pageModalService.defineNewPageModal();

    // this.routeSub = this.route.params.subscribe(e => this.getRouteParams(e));
    this.lastFillState = this.isQuestionFilled( this.getCurrentQuestionIndex() );
    this.getIframeURL();
    this.currSection = this.getCurrentSectionIndex().toString()

    if (this.confirmReportData){
      this.previousSessionMeta = JSON.parse(this.confirmReportData?.["prevSessionMeta"]);
    }
    // console.log(this.previousSessionMeta)
    if( this.previousSessionMeta ){
      Object.keys(this.previousSessionMeta).forEach(key =>{
        this.sectionTimeSpent[key] = this.previousSessionMeta[key].timeSpent;
      })
    }

    if(this.confirmReportData) {
      this.dayStarted = this.confirmReportData?.["dateTimeStart"]._d.getDate();
      this.yearStarted = this.confirmReportData?.["dateTimeStart"]._d.getFullYear();
    }

    if(this.isOnBreak && this.isWellnessBreakAvailable()){
      // need to include the session meta as it gets added at the confirmation of the session submission which in this scenario have already happened
      // then the applicant left the test or reloaded the page
      this.sectionSubmissionPrep();
      this.onWellnessBreak(() => this.gotoNextSection());
    }
    this.initElementLogService();
    this.initMirotalk();

    if(this.showFPS){
      this.checkTimeOut();
      this.userInactive.subscribe(() => this.userIdling = true);
      this.initFpsCheck();
      this.perfTestStartDate = new Date();
    }
    this.interactionTracking.setLogFunction(this.logStudentAction.bind(this));

  }

  initToolbarOption(){
    let defaults = {
      zoomIn : true,
      zoomOut: true,
      lineReader: true,
      hiContrast: true,
      toggleEditor: true,
      highlighter: true,
      eraser: true,
      notepad: true,
      infoButton: true
    }

    if(this.asmtFmrk && !this.asmtFmrk.toolbarOptions) this.asmtFmrk.toolbarOptions = defaults
  }

  elementLogSub: Subscription;
  initElementLogService() {
    this.elementLogSub = this.elementLog.onResponseChange.subscribe(this.logElementResponse.bind(this))
  }

  logElementResponse(data: ILogResponse) {
    this.logStudentAction(STUDENT_ACTIVITY_SLUGS.STUDENT_ASMT_ITEM_RESPONSE,{info: data, qId: this.getCurrentQuestionId()});
  }

  numDebugAggTrigger = 0;
  async triggerDebugModeAgg(){
    this.numDebugAggTrigger ++;
    if (this.numDebugAggTrigger >= 10){
      this.numDebugAggTrigger = 0;
      this.triggerDebugMode();
    }
  }
  async triggerDebugMode(){
    const password  = prompt('Enter DEBUG');
    if (password){
      try {
        const {isValid} = await this.auth.apiCreate('public/student/debug', {password})
        if (isValid){
          this.isDebugMode = true;
          this.devtoolsDetect.debugModePass = password;
        }
      }
      catch(e){
        alert('Please contact technical support.')
      }
    }
    this.numDebugAggTrigger = 0;
  }


  documentMap:Map<number, IQuestionConfig> = new Map();
  activeDocument
  loadDocument(itemId:number){
    return new Promise((resolve, reject) => {
      const item = <any>this.questionSrcDb.get(itemId);
      this.documentMap.set(+itemId, item);
      resolve(item);
    })
  }

  selectDocumentView(itemId:number){
    this.selectedDocumentId = itemId
    this.activeDocument = this.documentMap.get(itemId);
  }

  ngAfterViewInit() {
    this.scheduleCurrentQuestionFocus();
  }

  getCurrentQuestionHeadingText(): string {
    if (!this.testState) {
      return '';
    }
    if (this.isShowingSectionInfo) {
      return this.lang.tra('ie_preamble');
    }
    return `${this.lang.tra('title_stage')} ${this.testState.currentSectionIndex + 1}, ` +
      `${this.lang.tra('title_question')} ${this.testState.currentQuestionIndex + 1}`;
  }

  skipToCurrentQuestion(event: Event) {
    event.preventDefault();
    this.focusCurrentQuestionHeading();
  }

  private focusCurrentQuestionHeading() {
    const heading = this.currentQuestionHeading && this.currentQuestionHeading.nativeElement;
    if (heading && heading.isConnected) {
      // JAWS can retain the accessible name of a focused static element. Force a
      // fresh focus event after the complete heading text has reached the AX tree.
      if (document.activeElement === heading) {
        heading.blur();
      }
      heading.focus({preventScroll: true});
    }
  }

  private scheduleCurrentQuestionFocus() {
    if (this.currentQuestionFocusTimer !== undefined) {
      clearTimeout(this.currentQuestionFocusTimer);
    }
    if (this.currentQuestionFocusFrame !== undefined) {
      window.cancelAnimationFrame(this.currentQuestionFocusFrame);
    }
    this.currentQuestionFocusTimer = window.setTimeout(() => {
      this.currentQuestionFocusTimer = undefined;
      // Waiting for two animation frames gives Angular's DOM update a painted
      // frame before focus is exposed to screen readers such as JAWS.
      this.currentQuestionFocusFrame = window.requestAnimationFrame(() => {
        this.currentQuestionFocusFrame = window.requestAnimationFrame(() => {
          this.currentQuestionFocusFrame = undefined;
          this.focusCurrentQuestionHeading();
        });
      });
    });
  }

  private scheduleCompletionReportFocus(target: HTMLElement) {
    this.schedulePopupFocusAfterRender('completion-report', () => {
      if (target.isConnected) {
        target.focus();
      }
    });
  }

  private getActiveElement(): HTMLElement {
    const activeElement = document.activeElement as HTMLElement;
    return activeElement && activeElement !== document.body ? activeElement : null;
  }

  private schedulePopupFocusAfterRender(key: string, callback: () => void) {
    this.cancelPopupFocus(key);

    const firstFrame = window.requestAnimationFrame(() => {
      const secondFrame = window.requestAnimationFrame(() => {
        this.popupFocusFrames.delete(key);
        callback();
      });
      this.popupFocusFrames.set(key, secondFrame);
    });
    this.popupFocusFrames.set(key, firstFrame);
  }

  private cancelPopupFocus(key: string) {
    const frame = this.popupFocusFrames.get(key);
    if (frame !== undefined) {
      window.cancelAnimationFrame(frame);
      this.popupFocusFrames.delete(key);
    }
  }

  private restorePopupTrigger(key: string, target: HTMLElement) {
    if (target) {
      this.schedulePopupFocusAfterRender(key, () => {
        if (target.isConnected) {
          target.focus();
        }
      });
    }
  }

  private scheduleTimeRemainingFocus() {
    this.schedulePopupFocusAfterRender('time-remaining', () => {
      const target = this.timeRemainingMessage && this.timeRemainingMessage.nativeElement;
      if (target && target.isConnected) {
        target.focus();
      }
    });
  }

  private scheduleChatFocus() {
    this.schedulePopupFocusAfterRender('chat', () => {
      const target = this.chatHeading && this.chatHeading.nativeElement;
      if (target && target.isConnected) {
        target.focus();
      }
    });
  }

  lastFillState:boolean;
  checkAutoScroll(){
    const currentFillState = this.isQuestionFilled( this.getCurrentQuestionIndex() );
    if (currentFillState !== this.lastFillState){
      if (this.autoScrollOnSelect && currentFillState){
        const el = document.getElementById('btn-submit-question');
        if (el){
          el.scrollIntoView({behavior: 'smooth', block: 'end'});
        }
      }
      this.lastFillState = currentFillState;
    }
  }

  getIframeURL(){
    let url = window.location.protocol + "//" + window.location.host + "/assets/sci_calc/index.html"
    this.element.url = url;

  }
  setEraser(){
    this.showLine = false;
    this.showHighlight = false;
    if(this.isShowOverlay && !this.showDeactivatedMode){
      this.showEraser = true;
    }

  }
  setHighlighter(){
    this.showEraser = false;
    this.showLine = false;
    this.toggleZwibbler()
    if (!this.overlayState.deactivate && this.showHighlight){
      this.disableOverlay()
    }else{
      this.showHighlight = true;
    }

  }
  setLine(){
    this.showHighlight = false;
    this.showEraser = false;
    this.toggleZwibbler();
    if (!this.overlayState.deactivate && this.showLine){
      this.disableOverlay()
    }else{
      this.showLine = true;
    }


  }
  toggleZwibbler(){
   if (this.overlayState.off){
    this.overlayState.off = false;
     this.overlayState.on = true;
     this.isShowOverlay = true;
     return;
   }
   if (!this.overlayState.deactivate && this.showEraser){
      this.showEraser = false;
     return
   }


   if (this.overlayState.deactivate){
     this.overlayState.deactivate = false;
     this.showDeactivatedMode = false;
   }

  }
  disableOverlay(){
    this.showEraser = false;
    this.showHighlight = false;
    this.showLine = false;
    if (!this.overlayState.deactivate){
         this.overlayState.deactivate = true;
         this.showDeactivatedMode = true;
       }
  }

  getDrawingDisplayMode(){
    return DrawDisplayMode.TEST_RUNNER;
  }


  sectionTimer(sectionIndex: number){
      let sumOfPreviousSections = 0;
      for(let i=0; i<sectionIndex; i++){
        sumOfPreviousSections += this.sectionTimeSpent[i];
      }
      this.sectionTime = this.confirmReportData?.["timeSpent"] - sumOfPreviousSections;
      this.sectionTimeSpent[sectionIndex] = Math.round(this.sectionTime);
      this.sessionMeta = { [this.currSection] : concatObjects(this.sessionMeta[this.currSection], {timeSpent : this.sectionTimeSpent[sectionIndex]}) }
  }


  initTicker(){
    this.sectionTimeStarted = (new Date()).valueOf();
    // to do: this is not correct... it should be when they start a section and it should be persisted to the db
    this.ticker = setInterval(() => {
      const section = this.getCurrentSection();
      // console.log('section', section)
      this.checkAutoScroll(); // this has nothing to do with the timer countdown disp[lay]
      if (section && section.isTimeLimit) {
        let secondsRemaining = this.getCurrentSection().timeLimitMinutes * 60;
        let secondsSpent = ((new Date()).valueOf() - this.sectionTimeStarted) / 1000;
        secondsRemaining -= secondsSpent;
        let secondsDisplay = Math.round(secondsRemaining % 60);
        // console.log('getSectionTimeRemaining', secondsSpent)
        let minutesDisplay = Math.round((secondsRemaining - secondsDisplay) / 60);
        this.sectionTimeRemaining = this.leadingZero(minutesDisplay) + ':' + this.leadingZero(secondsDisplay);
      }
    }, 100);
  }


  initChatPage(){
    this.chatService.isSupervisor = false;
    this.chatService.isInvigilator = false;
    this.chatService.isTestTaker = true;
    this.chatService.uid = this.auth.user().value.uid;
    this.chatService.markingPoolId = this.testSessionId;
    // this.chatService.selectedMarker = this.markerId;
    this.chatService.group_id = this.instit_group_id;
    this.chatService.initSocket();
    const processSocketReconnection = () => this.chatService.disconnect();
    // setInterval(processSocketReconnection, 3000000);
  }

  initHelpPage(){
    if (this.helpPageItem){
      this.helpScreenLayout = this.questionSrcDb.get(+this.helpPageItem);
    }
    else{
      return this.auth
        .apiGet(this.routes.TEST_TAKER_DATA_DOWNLOAD, 0)
        .then(helpScreenLayout =>{
          if (this.isLang('en')){
            this.helpScreenLayout = <any> helpScreenLayout;
          }
          else {
            this.helpScreenLayout = <any> {
              ... helpScreenLayout,
              ... helpScreenLayout.langLink,
            };
          }
        })
    }
  }

  ngOnDestroy() {
    if (this.currentQuestionFocusTimer !== undefined) {
      clearTimeout(this.currentQuestionFocusTimer);
    }
    if (this.currentQuestionFocusFrame !== undefined) {
      window.cancelAnimationFrame(this.currentQuestionFocusFrame);
    }
    this.popupFocusFrames.forEach(frame => window.cancelAnimationFrame(frame));
    this.popupFocusFrames.clear();
    this.clearQuestionResaveInterval();
    clearInterval(this.ticker);
    this.logQuestionActivity(EXCLUDE_ITEM_OPEN_LOG_REASONS.NG_DESTROY);
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }

    if (this.verificationIntervalId) {
      clearInterval(this.verificationIntervalId);
    }

    if (this.mirotalkSub) this.mirotalkSub.unsubscribe();
    
    if (this.backgroundDiagnosticsInterval) clearInterval(this.backgroundDiagnosticsInterval);

    if(this.elementLogSub) {
      this.elementLogSub.unsubscribe();
    }
    this.interactionTracking.cleanup();
  }
  toggleTextToSpeech() {
    this.textToSpeech.toggle();
  }
  isTextToSpeechActive() {
    return this.textToSpeech.isActive;
  }
  toggleHelpScreen() {
    //console.log(this.helpScreenLayout)
    if(this.isHelpOverlay){
      document.getElementById("quest-cont").style.display = "flex"
      this.isHelpOverlay = false;
    }
    else{
      document.getElementById("quest-cont").style.display = "none"
      this.isHelpOverlay = true;
    }
  }
  getHelpScreenLayout(){
    return this.helpScreenLayout;
  }

  saveCounter = 0;
  private _saveQuestion() {
    if (this.isSavingResponse) {
      reject();
    }
    this.isSavingResponse = true;
    return new Promise<void>((resolve, reject) => {
      const content = this.getActiveQuestionContent();
      const test_question_version_id = content ? content.test_question_version_id : 0;
      const saveQuestionAndHandleErrors = async () => {
        this.isSavingResponse = true;
        const test_question_id = this.getActiveQuestionId();
        const response_raw = JSON.stringify(this.getActiveQuestionState());
        if (this.isDebugMode) {
          try {
            const {
              formatted_response,
              score,
              weight
            } = await this.auth.apiPatch('public/student/debug', test_question_id, { response_raw, password: this.devtoolsDetect.debugModePass })

            this.lastResponseDebug = {
              label: this.getQuestionLabel(test_question_id),
              test_question_id: test_question_id,
              score,
              weight,
              formatted_response
            }
          }
          catch (e) {
            this.lastResponseDebug = null;
            console.error('Error capturing last response')
          }
        }
        this.saveQuestion({
          test_question_id: this.getActiveQuestionId(),
          test_question_version_id,
          question_index: this.getCurrentQuestionIndex(),
          section_index: this.getCurrentSectionIndex(),
          response_raw: JSON.stringify(this.getActiveQuestionState()),
          response: this.getActiveQuestionResponse(),
          attempt_hash: this.attemptHash,
        })
          .then(() => {
            this.isSavingResponse = false;
            if(this.isPaused){
              this.isPaused = false;
              this.loginGuard.confirmationReqActivate({
                caption: "mpt_msg_attempt_resumed",
                hideCancel: true,
              });
            }
            resolve();
          })
          .catch(e => {
            console.log(e)
            this.isSavingResponse = false;
            const questionSaveErr: IQuestionSaveError = this.parseQuestionSaveError(e.message);

            if (!questionSaveErr) {
              this.loginGuard.confirmationReqActivate({
                caption: 'msg_save_question_err',
                hideCancel: true,
                btnProceedCaption: this.lang.tra('btn_retry'),
                confirm: () => {
                  saveQuestionAndHandleErrors();
                }
              })
            } else {
              let config: any = {};
              if (e.message === 'ERR_NEW_CONNECTION') {
                // force logout
                config = {
                  hideCancel: true,
                  btnProceedCaption: this.lang.tra('btn_ok'),
                  confirm: () => {
                    return this.auth.forceLogout(this.lang.getCurrentLanguage(), this.auth.myAccountType());
                  }
                }
              }
              if (e.message === 'CONFERENCE_REQUESTED') {
                if (this.verificationCallActive) return;
                config = {
                  hideCancel: true,
                  btnProceedCaption: this.lang.tra('lbl_ok'), // Open link, lbl_ok
                  confirm: () => {
                    this.openPrivateVideoCall();
                  },
                }
              }
              if(questionSaveErr.dismiss){
                config = {
                  hideCancel: true,
                  btnProceedCaption: this.lang.tra('btn_dismiss'),
                }
              }
              if(questionSaveErr.customBtn){
                config = {
                  hideCancel: true,
                  btnProceedCaption: this.lang.tra(questionSaveErr.btn),
                }
              }
              if(questionSaveErr.customBtn){
                config = {
                  hideCancel: true,
                  btnProceedCaption: this.lang.tra(questionSaveErr.btn),
                }
              }
              if(!questionSaveErr.skip){
                this.loginGuard.confirmationReqActivate({
                  caption: this.lang.tra(questionSaveErr.slug),
                  ...config
                });
              }
              if(questionSaveErr.errorAction){
                questionSaveErr.errorAction();
              }
              reject(e);
            }
          });
        }
        saveQuestionAndHandleErrors();
      });
  }

  getLogo(){
    let url;
    if (this.lang.c() === 'en'){
      url = this.whitelabel.getSiteText('asmt_logo_en')
    }
    else if (this.lang.c() === 'fr'){
      url = this.whitelabel.getSiteText('asmt_logo_fr')
    }
    return url;
  }

  getLogoSafe(){
    return this.safeUrl.sanitize(this.getLogo());
  }

  parseQuestionSaveError(msg: string):IQuestionSaveError {
    let dismiss = false; // todo: to be deprecated and replaced with customBtn
    let skip = false;
    let customBtn = false;
    let errorAction:() => void = undefined // a slot for nested secondary function if needed
    let slug = "";
    let btn = "btn_ok";
    switch (msg) {
      case 'TIME_OUT':
        slug = 'msg_max_time';
        break;
      case 'NOT_BOOKED_APPL':
        slug = 'msg_no_longer_booked';
        break;
      case 'ATTEMPT_CLOSED':
        slug = 'msg_already_submitted';
        break;
      case 'SESSION_CLOSED':
        slug = 'msg_ses_clsd';
        break;
      case 'SESSION_ENDED':
        slug = 'msg_already_ended';
        break;
      case 'MARKED_NO_ID':
        slug = 'msg_photo_id_error';
        break;
      case 'MARKED_ABSENT':
        slug = 'msg_absent';
        break;
      case 'NOT_VERIFIED':
        slug = 'msg_identity_error';
        break;
      case 'ATTEMPT_PAUSED':
        // No need to ping the applicant that they've been paused on every minute that passes while they are paused.
        //   They only need to see it once.
        if(this.isPaused){
          skip = true;
        }else{
          this.isPaused = true;
          dismiss = true; // todo: refactor by using customBtn insteads of specficially calling for dismiss slug
          slug = 'mpt_msg_attempt_paused';
        }
        break;
      case 'SESSION_PAUSED':
        slug = 'msg_session_paused';
        break;
      case 'ERR_NEW_CONNECTION':
        slug = 'msg_err_new_connection';
        break;
      case 'APPLICANT_ON_BREAK':
        if(this.isWellnessBreakAvailable()){
          errorAction = () => this.onWellnessBreak(() => this.gotoNextSection());
        }else{
          errorAction = () => this.updateWellnessBreak(false);
        }
        skip = true;
        break;
      case 'CONFERENCE_REQUESTED':
        this.isConferenceRequested = true;
        slug = 'mpt_msg_conference_requested';
        break;
      default:
        slug = 'msg_save_question_err';
        break;
    }
    return {slug, dismiss, skip, btn, customBtn, errorAction};
  }

  getActiveQuestionResponse() {
    const state = this.getActiveQuestionState();
    const responses = [];
    Object.keys(state).forEach(entryId => {
      const eRes = state[entryId];
      if (eRes.selections && eRes.selections[0]) {
        const entryResponses = eRes.selections.map(s => s.i);
        responses.push(entryResponses.join(','));
      }
    });
    return responses.join(';');
  }

  // getRouteParams(routeParams: any) {
  //   this.initTestDef();
  //   this.initTestState();
  // }

  initTestDef() {
    // compute section meta (mostly for the progress bar)
    let qsPrec = 0;
    this.currentTestDesign.sections.forEach(section => {
      const qs = section.questions.length;
      let meta: ISectionMeta = { qs, qsPrec, };
      section.__meta = meta;
      qsPrec += qs;
    });
    const qsTotal = qsPrec;
    // store the total number of questions
    this.currentTestDesign.__meta = {qs: qsTotal};
    // compute the position of the marker on the progress bar
    this.currentTestDesign.sections.forEach(section => {
      const m = section.__meta;
      const qIG = m.qsPrec + m.qs;
      const proportion = qIG / qsTotal;
      const markLoc = this.renderLocProp(proportion);
      section.__meta.markLoc = markLoc;
    });
  }

  hasToolbarOverflow() {
    const toolbarElement = this.toolbarRef?.nativeElement;

    if (toolbarElement) {
      const hasOverflow = toolbarElement.scrollHeight > toolbarElement.clientHeight;
      if (!hasOverflow) return false;

      // Check if scrolled to bottom (or very close to it, within 5px tolerance)
      const scrollBottom = toolbarElement.scrollHeight - toolbarElement.scrollTop - toolbarElement.clientHeight;
      const isAtBottom = scrollBottom <= 5;

      return !isAtBottom;
    }
    return false;
  }

  private renderLocProp(p: number, asNum: boolean= false) {
    return Math.round(100 * p) + (asNum ? '' : '%');
  }

  showSectionInfo() {
    if (this.getCurrentSectionPreambleContent()) {
      this.isShowingSectionInfo = true;
      this.scheduleCurrentQuestionFocus();
    }
  }
  hideSectionInfo() {
    this.isShowingSectionInfo = false;
    this.logQuestionActivity(); // if first question is preamble then on hide we need to log navigation to first question
    this.scheduleCurrentQuestionFocus();
  }

  getCurrentProgressLoc(asNum: boolean= false) {
    const section = this.getCurrentSection();
    const qIR = this.getCurrentQuestionIndex() + 1;
    const qsTotal = this.currentTestDesign.__meta.qs;
    const qIG = section.__meta.qsPrec + qIR;
    const proportion = qsTotal === 0 ? 1 : qIG / qsTotal;
    return this.renderLocProp(proportion, asNum);
  }

  initTestState() {
    this.testState = {
      languageCode: this.testLang,
      currentSectionIndex: this.sectionIndexInit,
      currentQuestionIndex: this.questionIndexInit,
      questionStates: this.questionStates,
    };
    if(this.testState.currentQuestionIndex > this.getCurrentQuestions().length-1 || this.testState.currentQuestionIndex < 0 ){
         this.testState.currentQuestionIndex = 0;}
    if (this.testState.currentQuestionIndex === 0) {
      if (this.getCurrentSectionPreambleContent()) {
        this.isShowingSectionInfo = true;
      } else {
        this.logQuestionActivity()
      }
    }
  }

  activateModal(caption: string, confirm: any, btnProceedCaption?:string, btnCancelCaption?:string) {
    this.loginGuard.confirmationReqActivate({
      caption,
      confirm,
      btnProceedCaption,
      btnCancelCaption,
    });
  }

  getDate(){
    let monthIndex = 0;
    if (this.showFPS) {
      const now = new Date();
      monthIndex = now.getMonth();
      this.dayStarted = now.getDate();
      this.yearStarted = now.getFullYear();
    }
    if (this.confirmReportData?.["dateTimeStart"]._d) {
      monthIndex = this.confirmReportData?.["dateTimeStart"]._d.getMonth();
    }
    return this.monthSlugs[monthIndex];
  }

  // to get bac to - not urgent
  getStartedAt(){
    let timeStamp = this.showFPS
      // ? this.timezone.moment(this.perfTestStartDate).toDate()
      ? this.perfTestStartDate
      : this.confirmReportData ? this.confirmReportData?.["dateTimeStart"]._d: new Date();
    let moment = this.timezone.moment(timeStamp);
    return this.convertTimeString(timeStamp);
  }

  getTimeSpentSinceStart(){
    if (this.showFPS){
      const now = new Date();
      // return thifference between now and this.perfTestStartDate
      const diff = now.getTime() - this.perfTestStartDate.getTime();
      const diffMinutes = Math.floor(diff / 1000 / 60);
      return diffMinutes + " minutes";
    }
      let timeSpent = 0;
      for(let el in this.sectionTimeSpent){
        if(this.sectionTimeSpent.hasOwnProperty(el)){
          timeSpent+= parseFloat(this.sectionTimeSpent[el])
        }
      }
      return this.timeConvert(timeSpent)
  }

 public convertTimeString = (date:Date) => {
    let timeString = '';
    if(this.lang.c() == 'en'){
      if(date.getUTCHours() < 12){
        timeString = date.getUTCHours()+ ":"
                      + (date.getMinutes()<10 ?'0':'')
                      +date.getMinutes()+ " AM";

      }else if(date.getUTCHours() === 12){
        timeString = date.getUTCHours()+ ":"
                      + (date.getMinutes()<10 ?'0':'')
                      +date.getMinutes()+ " PM";
      } else{
        timeString = date.getUTCHours() - 12 + ":"
                      + (date.getMinutes()<10 ?'0':'')
                      +date.getMinutes()+ " PM";
      }
    } else {
        timeString = (date.getUTCHours()<10 ?'0':'') +date.getUTCHours()+ "h"
                          + (date.getMinutes()<10 ?'0':'')+date.getMinutes();
    }

    return timeString;
  }

  public timeConvert= (num:number) => {
    let hours = Math.floor(num / 60);
    let minutes = Math.floor(num % 60);
    return hours + " "+this.lang.tra('txt_hours') +" "+ minutes + " minutes";
  }

  isWellnessBreakAvailable() {
    return this.getCurrentSection().hasWellnessBreak;
  }
  isFormulasAvailable() {
    return this.getCurrentSection().hasFormulas;
  }
  isCalcAvailable() {
    return this.getCurrentSection().hasCalculator;
  }
  isAttestation(section:number) {
    return this.getSection(section).is_attestation;
  }

  getCurrSectionTimeLimit(){
    const currentSection  = this.getCurrentSection();
    if(!currentSection?.isTimeLimit){
      return false;
    }
    return currentSection.isTimeLimit
  }

  getCurrentSectionIndex(): number {
    if (this.testState) {
      return this.testState.currentSectionIndex;
    }
    return -1;
  }
  getCurrentQuestionIndex(): number {
    if (this.testState) {
      return this.testState.currentQuestionIndex;
    }
    return -1;
  }
  getCurrentQuestionStates(): any {
    if (this.testState) {
      return this.testState.questionStates;
    }
    return {};
  }
  getCurrentSection(): ISectionDef {
    return this.getSection(this.getCurrentSectionIndex());
  }

  leadingZero(num) {
    if (num < 10) {
      return '0' + num;
    }
    return num;
  }
  getSectionTimeRemaining() {

  }

  getSection(i: number) {
    return this.currentTestDesign?.sections?.[i] || <any> {questions: []};
  }

  getCurrentQuestions(): number[] {
    return (this.getCurrentSection()).questions || [];
  }

  getSectionQuestions(sectionIndex: number){
    return (this.getSection(sectionIndex)).questions;
  }

  getActiveQuestionId() {
    const qId = this.getCurrentQuestions()[this.getCurrentQuestionIndex()];
    // if (!qId) {
      // console.warn('Null question');
    // }
    return qId;
  }

  getSectionPreambleContent(section: ISectionDef) {
    if(!section?.preamble){
      return undefined;
    }
    const content = this.getQuestionDef(section.preamble);
    return content;
  }
  getCurrentSectionPreambleContent() {
    // replaced getSectionInfoContent
    const section = this.getCurrentSection();
    const preambleContent = this.getSectionPreambleContent(section);
    return preambleContent;
  }

  getActiveQuestionContent() {
    const content = this.getQuestionDef(this.getActiveQuestionId());
    // console.log('content', content)
    return content;
  }

  getCurrentQuestionId(){
    const qIndex = this.getCurrentQuestionIndex()
    return this.getCurrentQuestions()[qIndex];
  }

  isCurrentQuestionFilled() {
    return this.isQuestionFilled(this.getCurrentQuestionIndex());
  }

  getQuestionNavAriaLabel(qIndex: number) {
    const parts = [
      `${this.lang.tra('title_question')} ${qIndex + 1}`,
    ];
    if (!this.isShowingSectionInfo && this.getCurrentQuestionIndex() === qIndex) {
      parts.push('current question');
    }
    parts.push(this.isQuestionFilled(qIndex) ? this.lang.tra('lbl_filled') : this.lang.tra('lbl_not_filled'));
    return parts.join(', ');
  }

  getQuestionAriaCurrent(qIndex: number) {
    return !this.isShowingSectionInfo && this.getCurrentQuestionIndex() === qIndex ? 'step' : null;
  }

  getAriaExpanded(isExpanded: boolean) {
    return isExpanded ? 'true' : 'false';
  }

  getAriaPressed(isPressed: boolean) {
    return isPressed ? 'true' : 'false';
  }

  getTestNavId() {
    return 'test-runner-question-nav';
  }

  getToolbarId() {
    return 'test-runner-toolbar';
  }

  getToolbarPanelId(panel: string) {
    return `test-runner-${panel}-panel`;
  }

  isQuestionFilled(qIndex: number) {
    const states = this.getCurrentQuestionStates();
    const qId = (this.getCurrentQuestions() || [])[qIndex];
    if (!qId) {
      return false;
    }
    let qState = states[qId];
    if (qState) {
      try {
        let isAllFilled = true;
        let isGlobalFilled = false;
        let isGlobalFilledOverride = (+qId === 9); // temporary
        let isAtLeastOneEntry = false;
        _.each(qState, entry => {
          isAtLeastOneEntry = true;
          if (!entry.isFilled) {
            isAllFilled = false;
          }
          else {
            if (entry.isCorrect && (entry.isGlobalFill || isGlobalFilledOverride)) {
              isGlobalFilled = true;
            }
          }
        });
        // console.log(qId, isAllFilled, isGlobalFilled, !isAtLeastOneEntry)
        return isAllFilled || isGlobalFilled || !isAtLeastOneEntry;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  containsWideLoad() {
    const question = this.getActiveQuestionContent();
    let isMatch = false;
    if (question) {
      question.content.forEach( element => {
        if (element.elementType === ElementType.SBS) {
          isMatch = true;
        }
      });
    }
    return isMatch;
  }

  getActiveQuestionState() {
    const states = this.getCurrentQuestionStates();
    const qId = this.getActiveQuestionId();
    let qState = states[qId];
    if (!qState) {
      qState = states[qId] = {};
    }
    return qState;
  }

  getQuestionDef(questionId: number) {
    return <IQuestionConfig> {...this.questionSrcDb.get(questionId), id: questionId};
  }
  getQuestionLabel(questionId: number) {
    const question = this.getQuestionDef(questionId);
    console.log('test')
    if (question){
      return question.label;
    }
  }

  getCurrentQuestionTitle(questionIndex: number, questionObj: any): string {
    // 1. Return the custom caption if it exists
    if (questionObj && questionObj.caption) {
      return questionObj.caption;
    }
    // 2. Return the translated default label with the accurate counter
    return this.lang.tra('title_question') + ' ' + (questionIndex + 1);
  }

  sectionPrintDisplayRef = new Map();
  toggleSectionPrint(id:number){
    this.sectionPrintDisplayRef.set(id, !this.sectionPrintDisplayRef.get(id))
  }

  showCurrentQuestionLabel(){
    alert("Item Label for Lookup: " + this.getQuestionLabel(this.getActiveQuestionId()))
  }

  scrollQuestionIntoView() {
    if (!this.isPrintMode){
      const el = this.questionDisplay.nativeElement;
      el.scrollIntoView();
    }
  }

  selectSectionAndQuestion(sectionIndex, questionIndex) {
    this._saveQuestion().then(() => {
      if (sectionIndex !== this.testState.currentSectionIndex) {
        //this.sectionTimeStarted = (new Date()).valueOf();
      }
      this.testState.currentSectionIndex = sectionIndex;
      this.testState.currentQuestionIndex = questionIndex;
      this.scrollQuestionIntoView();
      this.scheduleCurrentQuestionFocus();
    });
  }

  selectQuestion(questionIndex) {
    // Restart the intreval on every question selection
    this.restartQuestionResaveInterval();
    // Reset the isPaused status so that if the applicant is paused and they
    //   navigate between questions, they will get the "you've been paused" popup
    //   as expected and start the isPaused logic again.
    this.isPaused = false;
    if(this.testState.currentQuestionIndex > this.getCurrentQuestions().length-1 || this.testState.currentQuestionIndex < 0 ){
       this.testState.currentQuestionIndex = questionIndex;
    }
    this.isShowingSectionInfo = false;
    this.isHelpOverlay = false;
    document.getElementById("quest-cont").style.display = "flex"
    if(!this.showDeactivatedMode && this.isShowOverlay){
      this.disableOverlay()
    }
    this._saveQuestion().then(() => {
      this.testState.currentQuestionIndex = questionIndex;
      this.clearTools(true, true);
      this.lastFillState = this.isQuestionFilled(questionIndex);
      this.logQuestionActivity();
      this.getCurrentState.emit({
        section: this.getCurrentSection(),
        sectionIndex: this.getCurrentSectionIndex(),
        questionIndex: this.getCurrentQuestionIndex(),
        questions: this.getCurrentQuestions(), // add qindx
        questionId: this.getCurrentQuestionId(),
        questionStates: this.getCurrentQuestionStates(),
      })
      if (!this.isPrintMode){
        window.scrollTo(0, 0);
      }
      this.scheduleCurrentQuestionFocus();
    });
  }

  clearTools(keepCalc: boolean = false, keepDocuments: boolean = false) {
    this.isFormulasToggledOn = false;
    if (!keepDocuments) {
      this.isShowDocuments = false;
    }
    if (!keepCalc) {
      this.isCalcToggledOn = false;
    }
  }

  blockMoveAwayFromReqQuestion() {
    let isBlocked = false;
    const questions = this.getCurrentQuestions();

    for (let qIndex = 0; qIndex < questions.length; qIndex++) {
      const qId = questions[qIndex];
      const question = this.getQuestionDef(qId);

      if (question && question.isReqFill) {
        let entryIds = [];

        if (question.reqFillEntries) {
          entryIds = question.reqFillEntries.split(',').map(str => str.trim());
        }

        let isMissingRequirement = false;
        if (entryIds.length > 0) {
          const qState = this.getQuestionState(qId);
          if (!qState) {
            isMissingRequirement = true;
          } else {
            entryIds.forEach(id => {
              if (!qState[id] || !qState[id].isFilled) {
                isMissingRequirement = true;
              }
            });
          }
        }
        else {
          if (!this.isQuestionFilled(qIndex)) {
            isMissingRequirement = true;
          }
        }

        if (isMissingRequirement) {
          const errorMsg = question.reqFillMsg || 'lbl_questions_req_unfilled';

          this.loginGuard.confirmationReqActivate({
            caption: errorMsg,
            hideCancel: true
          });

          isBlocked = true;
          break; 
        }
      }
    }

    return isBlocked;
  }

  gotoNextQuestion() {
    if(this.testState.currentQuestionIndex > this.getCurrentQuestions().length-1 || this.testState.currentQuestionIndex < 0 ){
      this.testState.currentQuestionIndex = 0;
      this.selectQuestion(this.testState.currentQuestionIndex)
    } else{ this.selectQuestion(this.testState.currentQuestionIndex + 1); }
  }

  isOnLastQuestion() {
    return this.testState.currentQuestionIndex >= this.getCurrentQuestions().length - 1;
  }

  countNumCurrentQuestionsUnfilled() {
    let numUnfilled = 0;
    let questionIds = this.getCurrentQuestions();
    if (!questionIds) {
      console.error('no questions');
      return 0;
    }
    questionIds.forEach((qId, qIndex) => {
      if (!this.isQuestionFilled(qIndex)) {
        numUnfilled ++;
      }
    });
    return numUnfilled;
  }

  numUnfilledQuestInSection(sectionIndex:number, numUnFilled:number){
    this.numUnfilledQbySection= numUnFilled;
  }

  sectionSubmissionPrep() {
    const numUnfilled = this.countNumCurrentQuestionsUnfilled();
    this.numUnfilledQuestInSection(this.testState.currentSectionIndex, numUnfilled);
    this.sessionMeta = { [this.currSection] : {numUnfilledResponses : this.numUnfilledQbySection}}
  }

  reviewAndSubmit() {
    if (this.blockMoveAwayFromReqQuestion()) {
      return;
    }
    this.isNotepadEnabled = false;
    this.currSection = this.testState.currentSectionIndex.toString()
    this.overlayState.deactivate = true;
    this.showDeactivatedMode = true;
    const numUnfilled = this.countNumCurrentQuestionsUnfilled();
    let preMessage = '';
    if (numUnfilled > 0) {
      preMessage += this.lang.tra('mpt_alert_unfilled_questions', null, {questionNum: numUnfilled}) + ' ';
    }
    this.numUnfilledQuestInSection(this.testState.currentSectionIndex, numUnfilled);

    if(this.previousSessionMeta){
      console.log(this.currSection)
      if(!(this.currSection in this.previousSessionMeta)){
        this.sessionMeta = { [this.currSection] : {numUnfilledResponses : this.numUnfilledQbySection}}
      }
      else{
        this.previousSessionMeta[this.currSection].numUnfilledResponses = this.numUnfilledQbySection;
        this.sessionMeta = this.previousSessionMeta;
      }
    } else{
      console.log(this.currSection)
      this.sessionMeta = { [this.currSection] : {numUnfilledResponses : this.numUnfilledQbySection}}
    }
    // Restart the intreval on every section submission and test's final submission
    this.restartQuestionResaveInterval();
    // Reset the isPaused state so that if the applicant is paused they will be notified of
    //  their paused status and if a minute passes since their click on this function,
    //  they will not be auto re-notified of the same paused status, unless they trigger this again.
    this.isPaused = false;
    // check if the test will be done with this
    if (this.testState.currentSectionIndex >= this.currentTestDesign.sections.length - 1) {
      this.confirmAndSubmitTest(preMessage);
    }
    else {
      this.confirmAndSubmitSection(preMessage)
    }
  }

  private confirmAndSubmitSection(preMessage:string){
    this.clearTools();
    let isConfirmed:boolean;
    this.activateModal(preMessage + this.lang.tra(this.getAlertKKSubmitSectionSlug()), () => {
      if (isConfirmed){return;}
      isConfirmed = true;
      this._saveQuestion().then(() => {
        this.offerWellnessBreak(() => this.gotoNextSection());
      });
    }, this.lang.tra('alert_KK_SUBMIT_TEST_yes'), this.lang.tra('alert_KK_SUBMIT_TEST_no_simple') );
  }

  offerWellnessBreak(nextStep: () => void) {
    if(!this.isWellnessBreakAvailable()){
      nextStep();
      return;
    }

    this.loginGuard.confirmationReqActivate({
      caption: "tt_wellness_break_popup",
      btnProceedCaption: this.lang.tra("tt_wellness_break_choose"),
      btnCancelCaption: this.lang.tra("tt_wellness_break_proceed"),
      confirm: () => {
        this.updateWellnessBreak(true).then(() => {
          this.onWellnessBreak(nextStep);
        });
      },
      close: nextStep
    })
  }

  onWellnessBreak(nextStep: () => void) {
    this.loginGuard.confirmationReqActivate({
      caption: "tt_wellness_break_taken_popup",
      btnProceedCaption: this.lang.tra("tt_wellness_break_proceed_btn"),
      hideCancel: true,
      confirm: () => {
        this.updateWellnessBreak(false).then(() => {
          nextStep();
        })
      }
    });
  }

  private gotoNextSection(){
    this.isSubmitting = true
    const test_session_id = this.testSessionId
    this.currSection = this.testState.currentSectionIndex.toString()
    const sebFailSafe: number = this.seb.getSEBFaileSafeCheck();
    const validatedSEBConfig:number = this.auth.getSEBValidatorStatus();
    if(this.testState.currentSectionIndex === 0){
      this.sectionTime = this.confirmReportData?.["timeSpent"];
      this.sectionTimeSpent[0] = this.sectionTime ? Math.round(this.sectionTime) : 0;
      this.sessionMeta = { [this.currSection] : concatObjects(this.sessionMeta[this.currSection], {timeSpent : this.sectionTimeSpent[this.testState.currentSectionIndex]}) }
      this.auth.apiPatch(this.routes.TEST_TAKER_INVIGILATION_TEST_ATTEMPT,this.confirmReportData?.["attemptId"], this.sessionMeta, { query: {test_session_id, sebFailSafe, validatedSEBConfig, domain: getFrontendDomain()} }).then(res=>{
        this.previousSessionMeta = this.sessionMeta;
        console.log(this.previousSessionMeta)
      })
    } else {
      this.sectionTimer(this.testState.currentSectionIndex)
      if(this.previousSessionMeta){this.sessionMeta = concatObjects(this.previousSessionMeta,this.sessionMeta)}
      this.auth.apiPatch(this.routes.TEST_TAKER_INVIGILATION_TEST_ATTEMPT,this.confirmReportData?.["attemptId"], this.sessionMeta, { query: {test_session_id, sebFailSafe, validatedSEBConfig, domain: getFrontendDomain()} }).then(res=>{
        this.previousSessionMeta = this.sessionMeta;
        console.log(this.previousSessionMeta)
      })

    }
    this.processRouting().then(()=>{
      const section = this.testState.currentSectionIndex++;
      this.testState.currentQuestionIndex = 0;
      this._saveQuestion().then(async () =>{
        this.sectionTimeStarted = (new Date()).valueOf();
        this.isSubmitting = false;
        const isPreambleAvail = !!this.getCurrentSectionPreambleContent();
        if (isPreambleAvail) {
          this.isShowingSectionInfo = true;
          this.logQuestionActivity(EXCLUDE_ITEM_OPEN_LOG_REASONS.NEW_SECT_PREAMBLE);
        }
        else {
          this.isShowingSectionInfo = false;
          this.logQuestionActivity()
        }
        const isAttestation = this.isAttestation(section);
        if(isAttestation && this.acceptAttestation){
          await this.acceptAttestation(test_session_id);
        }
        this.scheduleCurrentQuestionFocus();
      })

    })
  }

  private processRouting(){
    const currentSectionIndex = this.testState.currentSectionIndex;
    return new Promise<void>((resolve, reject) => {
      if (this.testFormType === TestFormConstructionMethod.MSCAT){
        const currentSection:IPanelModuleDef = this.getSection(currentSectionIndex);
        const currentModuleId = currentSection.moduleId;
        let nextRoute:{module:string, minPropC:number, maxPropC};
        const panelRouting = this.currentTestDesign.panelRouting[''+currentModuleId];
        if (this.currentTestDesign.isPanelRoutingByNumCorrect){
          let propC = this.computePercentageCorrect(currentSectionIndex)
          // console.log('propC', propC)
          panelRouting.forEach(route => {
            if ( (route.minPropC === undefined) || (propC >= route.minPropC) ){
              if ( (route.maxPropC === undefined) || (propC < route.maxPropC) ){
                nextRoute = route;
              }
            }
          })
        }
        if (!nextRoute){
          alert('Number-Correct routing failed or is not enabled for this assessment panel, you will be routed to a random module option.');
          nextRoute = randArrEntry(panelRouting);
        }
        let nextPanelModule;
        this.currentTestDesign.panelModules.forEach(panelModule => {
          if (+panelModule.moduleId === +nextRoute.module){
            nextPanelModule = panelModule;
          }
        })
        console.log('next module', this.currentTestDesign.sections[currentSectionIndex+1]);
        // console.log('next module', nextPanelModule.moduleId);
        this.currentTestDesign.sections[currentSectionIndex+1].questions = nextPanelModule.questions;
        resolve();
      }
      else{
        resolve();
      }
    })
  }

  private computePercentageCorrect(sectionIndex:number) {
    let score = 0;
    let scoreMax = 0;
    const states = this.testState.questionStates;
    this.getCurrentQuestions().forEach(qId => {
      // console.log('states', states[qId]);
      const questionState = states[qId];
      if (questionState){
        let entryScore = 0;
        let entryScoreMax = 0;
        Object.keys(questionState).forEach(entryId => {
          // console.log('entry', questionState[entryId], questionState[entryId].score);
          const entryState = questionState[entryId];
          if (entryState && entryState.score){
            entryScore += +entryState.score;
          }
          entryScoreMax ++;
        });
        if (entryScoreMax > 0){
          score += entryScore / entryScoreMax;
        }
      }
      scoreMax ++;
    });
    if (scoreMax > 0){
      return score / scoreMax;
    }
    return 0;
  }

  private confirmAndSubmitTest(preMessage:string){
    this.currSection = this.testState.currentSectionIndex.toString()
    const test_session_id = this.testSessionId
    this.activateModal(preMessage + this.lang.tra(this.getAlertKKSubmitTestSlug()), () => {
      this.sectionTimer(this.testState.currentSectionIndex);
      if(this.previousSessionMeta){this.sessionMeta = concatObjects(this.previousSessionMeta,this.sessionMeta)}
      this.isSubmitting =true;
      const sebFailSafe: number = this.seb.getSEBFaileSafeCheck();
      const validatedSEBConfig:number = this.auth.getSEBValidatorStatus();
      this.auth.apiPatch(this.routes.TEST_TAKER_INVIGILATION_TEST_ATTEMPT,this.confirmReportData?.["attemptId"], this.sessionMeta, { query: {test_session_id, sebFailSafe, validatedSEBConfig, domain: getFrontendDomain()} }).then(res=>{
        this.previousSessionMeta = this.sessionMeta;
        this.isSubmitting = false;
        console.log(this.previousSessionMeta)
      })
      this._saveQuestion().then(r => {
        this.testState.isSubmitted = true;
        this.isShowingConfirmationReport = true;
        // console.log('submit test')
      });
    }, this.lang.tra('alert_KK_SUBMIT_TEST_yes'), this.lang.tra('alert_KK_SUBMIT_TEST_no_simple') );
  }

  confirmedSubmission(){
    this.loginGuard.confirmationReqActivate({
      caption: this.lang.tra('txt_warn_tt_final_submit'),
      confirm: () => this.submitTest()
    })
  }

  reportIssueThroughInvigilator(){
    this.loginGuard.confirmationReqActivate({
      caption: this.lang.tra('msg_confirm_report'),
      confirm: () => this.openChat()
    })
  }

  zoomIn() {
    if (this.zoomLevel + this.zoomIncrement <=  this.maxZoomLevel) {
      this.zoomLevel += this.zoomIncrement;
    }
  }
  zoomOut() {
    if (this.zoomLevel - this.zoomIncrement >=  this.minZoomLevel) {
      this.zoomLevel -= this.zoomIncrement;
    }
  }

  getDocumentTooltip(){
    if (this.documentItems && this.documentItems.length === 1){
      return this.documentItems[0].caption;
    }
    return this.lang.tra('lbl_documents')
  }


  sendIssueReport() {
    return this.auth.apiCreate(
      this.routes.TEST_TAKER_INVIGILATION_REPORT_ISSUE,
      {
        test_session_id: this.testSessionId,
        question_id: this.getActiveQuestionId(),
        message: this.issueReportMessage.value,
      }
    )
    .then(e => {
      this.isShowingReport = false;
    });
  }
  reportIssue() {
    this.isShowingReport = true;
  }
  checkTimeLeft() {
    // this.activateModal( this.lang.tra('alert_TIME_LEFT'), ()=>{} );
    if (this.checkTime) {
      this.checkTime();
    }
    if (!this.isShowingTime) {
      this.timeRemainingPreviouslyFocusedElement = this.getActiveElement();
    }
    this.isShowingTime = true;
    this.scheduleTimeRemainingFocus();
  }

  closeTimeRemaining() {
    this.isShowingTime = false;
    this.cancelPopupFocus('time-remaining');
    const focusTarget = this.timeRemainingPreviouslyFocusedElement;
    this.timeRemainingPreviouslyFocusedElement = null;
    this.restorePopupTrigger('time-remaining', focusTarget);
  }

  openChat() {
    if (this.checkChat) {
      this.checkChat();
    }
    if (!this.isShowingChat) {
      this.chatPreviouslyFocusedElement = this.getActiveElement();
    }
    this.isShowingChat = true;
    this.chatService.newMessage = false;
    this.scheduleChatFocus();
  }

  closeChat() {
    this.isShowingChat = false;
    this.chatService.newMessage = false;
    this.cancelPopupFocus('chat');
    const focusTarget = this.chatPreviouslyFocusedElement;
    this.chatPreviouslyFocusedElement = null;
    this.restorePopupTrigger('chat', focusTarget);
  }

  toggleTestNav() {
    this.isTestNavExpanded = !this.isTestNavExpanded;
  }
  toggleToolbar() {
    this.isToolbarExpanded = !this.isToolbarExpanded;
  }

  private lineReaderKeyboardDown = (event: KeyboardEvent) => {
    const baseStepX = 10;
    const baseStepY = 10;
    const fastRatio = 2.5;
    const slowRatio = 0.3;
    const defaultRatio = 1;
    let ratio = defaultRatio;
    let stepX: number;
    let stepY: number;

    if (event.shiftKey && event.ctrlKey) {
      ratio = defaultRatio;
    } else if (event.shiftKey) {
      ratio = fastRatio;
    } else if (event.ctrlKey) {
      ratio = slowRatio;
    }
    stepX = baseStepX * ratio;
    stepY = baseStepY * ratio;

    const pos = this.lineReaderPosition;
    switch (event.key) {
      case 'ArrowUp':
        this.lineReaderPosition = { x: pos.x, y: pos.y - stepY }; break;
      case 'ArrowDown':
        this.lineReaderPosition = { x: pos.x, y: pos.y + stepY }; break;
      case 'ArrowLeft':
        this.lineReaderPosition = { x: pos.x - stepX, y: pos.y }; break;
      case 'ArrowRight':
        this.lineReaderPosition = { x: pos.x + stepX, y: pos.y }; break;
    }
  }

  toggleLineReader() {
    this.isLineReaderActive = !this.isLineReaderActive;
    if (this.isLineReaderActive) {
      window.addEventListener('keydown', this.lineReaderKeyboardDown);
    } else {
      this.lineReaderPosition = {x:0, y:0};
      window.removeEventListener('keydown', this.lineReaderKeyboardDown);
    }
  }

  toggleHiContrast() {
    this.isHighContrast = !this.isHighContrast;
  }

  toggleNotepad(){
    this.notePadLogState = {
      logOnChange: true,
      logOnBlure: false
    };
    this.isNotepadEnabled = !this.isNotepadEnabled;
  }

  toggleDocuments() {
    this.isShowDocuments = !this.isShowDocuments;
  }

  toggleFormula() {
    this.isShowFormulaSheet = !this.isShowFormulaSheet;
  }

  toggleFormulas() {
    this.isFormulasToggledOn = !this.isFormulasToggledOn;
  }

  toggleCalc() {
    this.isCalcToggledOn = !this.isCalcToggledOn;
    // if (this.isCalcToggledOn) {
    //   this.slowScrollToTop();
    // }
    this.logTool("CALC", {isCalcToggledOn: this.isCalcToggledOn, qId: this.getCurrentQuestionId()});
  }

  handleBlur() {
    this.notePadLogState.logOnChange  = true;
    if (this.notePadLogState.logOnBlure === false) {
      return;
    }
    this.notePadLogState.logOnBlure = false;
  }

  logStartTyping(): void {
    if (this.notePadLogState.logOnChange === false) {
      return;
    }
    this.notePadLogState.logOnChange = false;
    this.notePadLogState.logOnBlure = true;
  }

  slowScrollToTop() {
    const el = this.questionDisplay.nativeElement;
    el.scrollIntoView({block: 'start'});
    setTimeout(() => {
      const elt = this.topBar.nativeElement;
      elt.scrollIntoView({behavior: 'smooth', block: 'end'});
    }, 100);
  }

  isLang(langCode: string) {
    return (langCode === this.testLang);
  }

  isShowingCalc() {
    return this.isCalcToggledOn;
  }

  getQuestionTitleSlug(){
    return 'title_question';
  }

  getScrollingSlug() {
    return "tool_bar_scrolling_tooltip";
  }

  getSectionTitleSlug() {
    switch (this.testFormType){
      case TestFormConstructionMethod.MSCAT: return 'title_stage';
      default: return 'title_section';
    }
  }

  getSectionTimeRemainingSlug() {
    switch (this.testFormType){
      case TestFormConstructionMethod.MSCAT: return 'tr_stage_time_remaining';
      default: return 'tr_section_time_remaining';
    }
  }

  getAlertUnfilledWarnP2Slug() {
    switch (this.testFormType){
      case TestFormConstructionMethod.MSCAT: return 'alert_UNFILLED_WARN_P2_STAGE_simple';
      default: return 'alert_UNFILLED_WARN_P2_simple';
    }
  }

  getAlertKKSubmitSectionSlug() {
    switch (this.testFormType){
      case TestFormConstructionMethod.MSCAT: return 'alert_KK_SUBMIT_STAGE';
      default: return 'alert_KK_SUBMIT_SECTION';
    }
  }

  getAlertKKSubmitTestSlug() {
    switch (this.testFormType){
      case TestFormConstructionMethod.MSCAT: return 'alert_KK_SUBMIT_STAGE';
      default: return 'alert_KK_SUBMIT_TEST';
    }
  }

  /**
   * This function sets up an intreval that triggers the _saveQuestion function every minute
   */
  private restartQuestionResaveInterval(){
    this.clearQuestionResaveInterval();
    this.questionResaveInterval = setInterval(() => {
      this._saveQuestion();

      const activeQuesId = this.getActiveQuestionId();
      if(activeQuesId === this.previousLoggedItemOpenId) {
        this.logStudentAction(STUDENT_ACTIVITY_SLUGS.STUDENT_TEST_ITEM_KEEP_ALIVE, {qId: activeQuesId});
      }
    }, ITEM_RESAVE_INTERVAL)
  }

  /**
   * This function clears the ping every minute of question save intreval
   */
  private clearQuestionResaveInterval(){
    if (this.questionResaveInterval){
      clearInterval(this.questionResaveInterval);
    }
  }


  logStudentAction(slug:STUDENT_ACTIVITY_SLUGS | string, info: any, slugPrefix? : string, isSimulated = false) {
    let prefix = slugPrefix || "";
    prefix += "_";
    const payload = {
      slug: `${prefix}${slug}`,
      data: {
        uid: this.auth.getUid(),
        session_id: this.testSessionId,
        isSimulated,
        localTimestamp: +(new Date()),
        state: {
          section_index: this.testState.currentSectionIndex,
          question_index: this.testState.currentQuestionIndex
        },
        info
      }
    }
    if (this.isLogsVisible){
      payload['_info'] = JSON.stringify(payload.data.info)
      payload['counter'] = this.logQueue.length;
      this.logQueue.unshift(payload)
    }
    if(this.auth.userIsStudent()) {
      this.auth.apiCreate( this.routes.LOG, payload)
    }
  }
  logTool(toolSlug: string, info: any) {
    this.logStudentAction(toolSlug, info, "STUDENT_ASMT_TOOL")
  }

  logCalculatorAction(): void {
    this.logStudentAction("STUDENT_CALC_INPUT", {qId: this.getCurrentQuestionId()})
  }

  exportLogsJson(){
    for (let record of this.logQueue){
      delete record._info
    }
    downloadStr(JSON.stringify(this.logQueue, null, 2), 'test-runner-process-logs.json')
    for (let record of this.logQueue){
      record._info = JSON.stringify(record.data.info)
    }
  }

  logQuestionActivity(noNextItem?:EXCLUDE_ITEM_OPEN_LOG_REASONS) {
    const activeQuestionId = this.getActiveQuestionId();
    const questionStart = Date.now();
    const questionDuration = questionStart - (this.currentTestQuestionStartTime ?? questionStart);
    const isNewQuestion = activeQuestionId !== this.previousLoggedItemOpenId;
    if (this.previousLoggedItemOpenId && (noNextItem || isNewQuestion)) {
      this.logStudentAction(STUDENT_ACTIVITY_SLUGS.STUDENT_TEST_ITEM_NAVIGATE_AWAY, {
        qId: this.previousLoggedItemOpenId,
        questionDuration,
        noNextItem,
      });
    }

    /* if component is being destroyed there won't be an item to navigate to */
    if (!noNextItem && isNewQuestion) {
      this.logStudentAction(STUDENT_ACTIVITY_SLUGS.STUDENT_TEST_ITEM_OPEN, {
        qId: activeQuestionId,
      });
    }
    if(noNextItem){ // if not logging next item intentionally set previous logged question to null
      this.previousLoggedItemOpenId = null;
    } else {
      this.previousLoggedItemOpenId = activeQuestionId;
    }

    if(isNewQuestion){ // only reset question time if it is a new question
      this.currentTestQuestionStartTime = questionStart;
    }
  }

  logsFilterIn
  logsFilterOut
  private strBitsOverlap(str:string, bitsStr:string){
    const bits = bitsStr.split(',').map(bit => bit.trim())
    for (let bit of bits){
      if (bit && str.includes(bit)){
        return true
      }
    }
    return false
  }
  checkShowLog(eventSlug:string){
    if (this.logsFilterOut && this.strBitsOverlap(eventSlug, this.logsFilterOut)){
      return false
    }
    if (this.logsFilterIn && !this.strBitsOverlap(eventSlug, this.logsFilterIn)){
      return false
    }
    return true;
  }

  getQuestionState(questionId: number) {
    const states = this.getCurrentQuestionStates();
    if(!states){
      return {};
    }
    return states[questionId];
  }
  // Add new properties for video verification
  public verificationCallActive: boolean = false;
  private verificationIntervalId: any;
  private videoCallRequestSub : Subscription;
  public pendingVideoCallRequest: IVideoCallRequest | null = null;
  public isShowingVideoCallRequest: boolean = false;

  private openPersonalCallLinkFallBack(link: string) {
    const a = document.createElement('a');
    a.href = link;
    a.target = '_blank';
    a.style.display = 'none'; // Hide the link
    document.body.appendChild(a);
    // const callWindow = window.open(link, '_blank');
    a.click();
    document.body.removeChild(a);
    // return callWindow;
  }


  privateCallLink: string | SafeResourceUrl = '';
  privateCallStart: boolean = false;
  isPrivateRoomReady: boolean | undefined = undefined;
  private async openPrivateVideoCall() {
    const thisSessionId = this.testSessionId;
    const uid = this.auth.getUid();
    const ttName = this.remoteProctoringService.formatUsername(this.testTakerName);
    const verificationRoomId = this.remoteProctoringService.generatePrivateRoomId(thisSessionId, uid.toString());
    try {
      this.isPrivateRoomReady = await this.remoteProctoringService.isRoomReady(verificationRoomId);
    } catch (error) {
      console.warn('Error checking meetings room status. Pursuing to fallback.', error);
    }
    if (this.isPrivateRoomReady === false) {
        setTimeout(() => this._handlePrivateCallNotReady(), 5); // to properly show the popup
      return;
    }
    const cLang = this.testLang || 'en';
    // const urlStringP2p = `https://p2p.mirotalk.com/join?room=${this.verificationRoomId}&name=${this.testTakerName}&avatar=0&audio=0&video=1&screen=0&hide=0&notify=0`;
    const urlStringSfu = `${MPT_REMOTE_PROCTOR_DOMAIN}/join?room=${verificationRoomId}&name=${ttName}&avatar=0&audio=1&video=1&screen=0&hide=0&notify=0&lang=${cLang}`;
    this.privateCallLink = this.sanitizer.bypassSecurityTrustResourceUrl(urlStringSfu);
    try {
      // call through modal
      const config: any = {};
      this.pageModal.newModal({
        type: PrivateCallModal.PRIVATE_CALL_MODAL,
        config,
        isProceedOnly: true,
        confirmationCaption: this.lang.tra('lbl_return_test'),
        finish: () => {
          this.handlePersonalVideoCallClose();
        }
      })
      this.verificationCallActive = true;
    } catch (error) {
      console.error('failed to open window, trying via link');
      this.openPersonalCallLinkFallBack(urlStringSfu);
      this.patchCandidateVideoCallRequest();
    }
  }

  private async patchCandidateVideoCallRequest() {
  const sebFailSafe: number = this.seb.getSEBFaileSafeCheck();
    const validatedSEBConfig:number = this.auth.getSEBValidatorStatus();
    try {
      const res = await this.auth.apiPatch(this.routes.TEST_TAKER_INVIGILATION_TEST_ATTEMPT,this.confirmReportData?.["attemptId"], {isVideoOpened: true}, {
      query: {
        test_session_id: this.testSessionId, sebFailSafe, validatedSEBConfig, domain: getFrontendDomain(),
      },
      })
      if (res) {
        console.log('Video call updated', res);
      }
    } catch (error) {
      console.error("Failed to update video call status:", error);
    }
  }

  public reloadConference(): void {
    this.refreshConference.emit();
  }
  // handle private call in modal, and not in new window
  PrivateCallModal = PrivateCallModal;
  pageModal: PageModalController;
  cModal() { return this.pageModal.getCurrentModal(); }

  getToolbarBottomPadding(){
    return this.infoButton?.nativeElement?.clientHeight ?? 0;
  }

  // handleModalClosure:
  handlePersonalVideoCallClose() {
    this.privateCallStart = false;
    this.privateCallLink = '';
    this.verificationCallActive = false;
    this.pageModal.closeModal();
    if (this.isPrivateRoomReady) {
      this.patchCandidateVideoCallRequest();
    }
  }

  breakoutRoomId: string | undefined;
  getBreakoutRoomId () {
    const uid = this.auth.getUid();
    return this.remoteProctoringService.generatePrivateRoomId(this.testSessionId, uid.toString());
  }

/**
 * Initialize event listener for private room active status from Mirotalk
 */
  private initMirotalk() {
    this.breakoutRoomId = this.getBreakoutRoomId();
    console.log('STARTING EVENT LISTENER IN TEST-RUNNER')
    this.mirotalkEvent$ = this.remoteProctoringService
      .getRoomActiveEventMessage()
      .pipe(
        filter((event: MirotalkMessageEvent) => event.data.data.roomId === this.breakoutRoomId),
      );
    this.mirotalkSub = this.mirotalkEvent$.subscribe(message => {
      console.log("🚀 ~ test-runner.component.ts:1776 ~ TestRunnerComponent ~ initMirotalk ~ message:", message)
      if (message && message.data) {
        this.isPrivateRoomReady = message.data.data.isRoomActive;
        if (!this.isPrivateRoomReady) {
          console.log('PRIVATE ROOM NOT READY FROM EVENT')
          this._handlePrivateCallNotReady();
        }
      }
    });
  }

  private _handlePrivateCallNotReady() {
    console.log('PRIVATE ROOM NOT READY - handling and closing')
    this.handlePersonalVideoCallClose();
    this.loginGuard.quickPopup('Please wait until the invigilator is ready to receive you');
    return;
  }


  // FPS related methods

  ngAfterViewChecked(){
    this.frameCount++;
  }

  @HostListener('window:keydown')
  @HostListener('window:mousedown')
  @HostListener('window:mousemove')
  refreshUserState() {
    clearTimeout(this.timeoutId);
    this.userIdling = false
    this.checkTimeOut();
  }

  /**
   * Check if the user is inactive for a certain amount of time.
   * If inactive, emits a value on the userInactive observable.
   */
  checkTimeOut() {
    this.timeoutId = setTimeout(() => this.userInactive.next(undefined), IDLE_CHECK_FREQENCY);
  }

  initFpsCheck() {
    //check number of frame per second
    this.backgroundDiagnosticsInterval = setInterval(() => {
      this.runFpsCheck();
    }, FPS_CHECK_FREQENCY)
  }

  // will need to be refactored to account for getting the sum of the FPS
  runFpsCheck(){
    const nowTime = new Date();
    if (nowTime.getTime() > this.lastFrameLoopCheck.getTime() + FPS_CHECK_FREQENCY) {
      //calcualte fps
      const thisFrameTime = (nowTime.getTime() - this.lastFrameLoopCheck.getTime());
      const theFPS = this.frameCount * SECOND_MS / thisFrameTime
      const fpsFixed = +(theFPS.toFixed(2));

      // ignore initial warmup frames, usually slow - and 0 values
      if ((this.fpsSamples.length > 0 || fpsFixed > 5) && fpsFixed > 0) {
        this.fpsSamples.push(fpsFixed);
      }

      console.log("fps: "+fpsFixed);
      if(!this.currentFPS || !this.userIdling){  // update fps at begining or when user is not idling
        this.currentFPS = fpsFixed
        this.setFPSStatus()
      }
      this.lastFrameLoopCheck = nowTime
      this.frameCount = 0;
    }
  }

  setFPSStatus(){
    if(this.currentFPS > GOOD_FPS){
      this.currentFpsStatus = FPSStatus.GOOD
    }else if (this.currentFPS > POOR_FPS){
      this.currentFpsStatus = FPSStatus.ADEQUATE
    }else{
      this.currentFpsStatus = FPSStatus.POOR
    }

    switch(this.currentFpsStatus){
      case FPSStatus.GOOD:
        this.currentFpsStatusText = this.lang.tra('ts_fps_status_good')
        break;
      case FPSStatus.ADEQUATE:
        this.currentFpsStatusText = this.lang.tra('ts_fps_status_adequate')
        break;
      case FPSStatus.POOR:
      default:
        this.currentFpsStatusText = this.lang.tra('ts_fps_status_poor')
        break;
    }
  }

  public get fpsAverage(): number {
    if (this.fpsSamples.length === 0) return 0;
    const sum = this.fpsSamples.reduce((a, b) => a + b, 0);
    return +(sum / this.fpsSamples.length).toFixed(2);
  }

  getDeviceFingerprint() {
    return this.stressTestService.getDeviceFingerprint();
  }

  getTestAvgFps() {
    // stop interval to have final avg value
    clearInterval(this.backgroundDiagnosticsInterval);
    return this.fpsAverage;
  }

  getNotepadText() {
    const section = this.getCurrentSection();
    if (section && section.notepadText){
      return section.notepadText
    }
    return null
  }

  toggleInfoModal() {
    this.loginGuard.toggleInfoOverlay()
  }
}


export enum PrivateCallModal {
    PRIVATE_CALL_MODAL='PRIVATE_CALL_MODAL',
  }
